import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PATHS } from "@constants/Paths";
import { PeekScreenLoader } from "@piiqtechnologies/ui-components";
const AppLayout = React.lazy(() => import("@layouts/app"));
const Home = React.lazy(() => import("@pages/home"));
const Results = React.lazy(() => import("@pages/results"));
const AppRoutes = () => {
    return (React.createElement(Suspense, { fallback: React.createElement(PeekScreenLoader, { layered: true }) },
        React.createElement(Routes, null,
            React.createElement(Route, { element: React.createElement(AppLayout, null) },
                React.createElement(Route, { path: PATHS.HOME, element: React.createElement(Home, null) }),
                React.createElement(Route, { path: PATHS.RESULTS, element: React.createElement(Results, null) })))));
};
export default AppRoutes;
